<template>
  <div class="card period-card">
    <div class="card-header period-header">
      <span class="period-header__icon"><i class="ti ti-calendar"></i></span>
      <div>
        <strong>Periode Jadwal</strong>
        <small>Pilih bulan kerja</small>
      </div>
    </div>

    <div class="card-body">
      <date-picker
        v-model="model"
        :default-value="model"
        :disabled-date="disabledDate"
        :clearable="false"
        value-type="format"
        type="month"
        format="MM/YYYY"
        confirm
        style="width: 100%"
        @change="onChange"
      />

      <small class="period-help">
        Pilih periode untuk melihat dan mengatur jadwal shift.
      </small>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/id";

export default {
  name: "PeriodPanel",

  components: {
    DatePicker,
  },

  props: {
    value: {
      type: String,
      default: "",
    },
    disabledDate: {
      type: Function,
      default: null,
    },
  },

  data() {
    return {
      model: this.value,
    };
  },

  watch: {
    value(v) {
      this.model = v;
    },
  },

  methods: {
    onChange() {
      this.$emit("input", this.model);
      this.$emit("change", this.model);
    },
  },
};
</script>
<style scoped>
.period-card {
  border: 1px solid #e1e9ee;
  border-radius: 12px;
  box-shadow: 0 8px 22px rgba(47, 89, 111, 0.08);
  margin-bottom: 14px;
  overflow: hidden;
}

.period-header {
  align-items: center;
  background: #fff;
  border-bottom: 1px solid #e8eef2;
  display: flex;
  gap: 9px;
  padding: 13px 14px;
}

.period-header__icon {
  align-items: center;
  background: #eaf6f7;
  border-radius: 8px;
  color: #318a99;
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
}

.period-header strong,
.period-header small {
  display: block;
}

.period-header strong {
  color: #344f60;
  font-size: 12px;
}

.period-header small {
  color: #8a9ba6;
  font-size: 9px;
  margin-top: 2px;
}

.period-card .card-body {
  background: #f9fbfc;
  padding: 13px;
}

.period-card::v-deep .mx-input {
  border: 1px solid #d9e4e9;
  border-radius: 7px;
  box-shadow: none;
  min-height: 38px;
}

.period-card::v-deep .mx-input:focus {
  border-color: #83c4cb;
  box-shadow: 0 0 0 3px rgba(49, 147, 167, 0.1);
}

.period-help {
  color: #8296a2;
  display: block;
  font-size: 9px;
  line-height: 1.5;
  margin-top: 8px;
}
</style>
